import { useEffect, useState } from "react";
import { endpoints } from "../../../../ApiEndPoints/apiEndPoints";
import LoadingIndicator from "../../../Loading";
import { ApiCallStatus, ApiCallStatusStates } from "../../../../Types/ApiStatus";
import { FileDownloadParameters } from "../../../../Types/FileDownload";
import { useFileDownload } from "../../../../helpers/useFileDownload";

type DownloadVolumetricsReviewFileProps = {
    onDownloadComplete: (status: ApiCallStatus) => void;
}

const DownloadVolumetricsReviewFile = ({ onDownloadComplete }: DownloadVolumetricsReviewFileProps) => {
    const [shouldDownload, setShouldDownload] = useState<boolean>(true);

    const fileDownloadParameters: FileDownloadParameters = {
        endpoint: endpoints.downloadVolumetricsReviewFile(),
        fileDetails: {
            fileNamePrefix: "VolumetricsReview",
            FileType: "xlsx",
        },
        isEnabled: shouldDownload
    };

    const { fileDownloadStatus } = useFileDownload(fileDownloadParameters);

    useEffect(() => {
        if (fileDownloadStatus === ApiCallStatusStates.SUCCESS || fileDownloadStatus === ApiCallStatusStates.ERROR) {
            setShouldDownload(false);
            onDownloadComplete(fileDownloadStatus);
        }
    }, [fileDownloadStatus]);

    return (
        <LoadingIndicator isLoading={shouldDownload} />
    );
}

export default DownloadVolumetricsReviewFile;